import { Component } from 'react'
import PropTypes from 'prop-types'
import { Warning, X } from '@phosphor-icons/react'

class ConfirmPopup extends Component {
  constructor(props) {
    super(props)
    this.confirmAction = this.confirmAction.bind(this)
    this.cancelAction = this.cancelAction.bind(this)
    this.setIsRulesConfirmed = this.setIsRulesConfirmed.bind(this)
    this.className = props.className || ''
    this.state = {
      isRulesConfirmed: false,
      isLoading: false,
    }
  }

  async confirmAction(e) {
    e.preventDefault()
    this.setState({ isLoading: true })
    await this.props.confirmCallback()
    this.setState({ isLoading: false })
  }

  setIsRulesConfirmed() {
    this.setState({ isRulesConfirmed: !this.state.isRulesConfirmed ? 'on' : false })
  }

  cancelAction(e) {
    e.preventDefault()
    this.props.cancelCallback()
  }

  getButtonClass() {
    switch (this.className) {
      case 'is-success':
        return 'button-primary'
      case 'is-caution':
        return 'button-orange'
      case 'is-reminder':
        return 'button-black'
      case 'is-positive':
        return 'button-green'
      default:
        return 'button-red'
    }
  }

  getHeaderIcon() {
    switch (this.className) {
      case 'is-caution':
      case 'is-reminder':
        return <Warning />
      default:
        return null
    }
  }

  render() {
    const {
      isOpen,
      title,
      cancelText,
      confirmText,
      body,
      className,
      isLoading,
      autoWidth,
      confirmDisabled,
      style,
    } = this.props
    const isButtonLoading = isLoading !== undefined ? isLoading : this.state.isLoading
    return (
      <div
        className={`modal modal--confirm ${isOpen ? 'is-active' : ''} ${className || ''}`}
        style={style}
      >
        <div className="modal-background" />
        <div className={`modal-content ${autoWidth && 'modal-content--auto'}`}>
          <div className="box">
            <header className="modal__header">
              <div>
                {this.getHeaderIcon()}
                <span>{title}</span>
              </div>
              <div className="close-button" onClick={this.cancelAction}>
                <X />
              </div>
            </header>
            <div className="modal__inner">
              {body ? <div className="modal__body">{body}</div> : null}
              <div className="modal__section modal__actions">
                <button
                  className="button button-gray"
                  onClick={this.cancelAction}
                  disabled={isButtonLoading}
                >
                  {cancelText}
                </button>
                <button
                  className={`button ${this.getButtonClass()} ${
                    isButtonLoading ? 'is-loading' : ''
                  }`}
                  onClick={this.confirmAction}
                  disabled={isButtonLoading || confirmDisabled}
                >
                  {confirmText}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

ConfirmPopup.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string,
  cancelText: PropTypes.string,
  confirmText: PropTypes.string,
  confirmCallback: PropTypes.func,
  cancelCallback: PropTypes.func,
  body: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  className: PropTypes.string,
  isLoading: PropTypes.bool,
  autoWidth: PropTypes.bool,
  confirmDisabled: PropTypes.bool,
}

ConfirmPopup.defaultProps = {
  className: '',
}

export default ConfirmPopup
